import PeopleGroupIcon from '@atlaskit/icon/core/people-group';
import * as React from 'react';

export function SvgUsers() {
  return <PeopleGroupIcon label="" testId="ads-refreshed-icon" />;
}
